/* System defined core library */
import { Injectable, NgZone, SecurityContext } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import * as moment from 'moment';
import { Observable, Observer, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

/* User defined library/components */
import { BootstrapParams } from '../../../bootstrap-params';
import { HttpService } from '../../core/http.service';
import { SelectedExamDetailService } from '../../scheduling/shared/services/selected-exam-detail.service';
import { LoaderService } from './loader.service';

/* User defined models */
import { ContentResponse, TravserseModel } from '../models/common/shared.model';
import { AppointmentDetail } from '../models/scheduling/appointmentdetail.model';
import { AppointmentSearch } from '../models/scheduling/appointmentSearch.model';
import { AppointmentSummary } from '../models/scheduling/appointmentsummary.model';
import { Booking } from '../models/scheduling/booking.model';
import { Candidate } from '../models/scheduling/candidate.model';
import { Client } from '../models/scheduling/client.model';
import { Country } from '../models/scheduling/country.model';
import { Eligibility } from '../models/scheduling/eligibility.model';
import { Exam } from '../models/scheduling/exam.model';
import { Hold } from '../models/scheduling/hold.model';
import { LocationSelector } from '../models/scheduling/locationSelector.model';
import { Program } from '../models/scheduling/program.model';
import { SelectedDate } from '../models/scheduling/selectedDate.model';
import { State } from '../models/scheduling/state.model';

/* User defined enums/constants */
import { ComponentType, EntityType } from '../enums/scheduling.enum';


@Injectable()
export class UtilityService {


    private recursiveResult: any = [];
    public canRedirectToLogin: boolean = false;
    public previousUrl: string = "";
    public dateFormatToMMDDYYYY = "mm/dd/yyyy";
    public candidate: Candidate;

    public monthsMap = {
        "jan": "January",
        "feb": "February",
        "mar": "March",
        "apr": "April",
        "may": "May",
        "jun": "June",
        "jul": "July",
        "aug": "August",
        "sep": "September",
        "oct": "October",
        "nov": "November",
        "dec": "December",
    };

    public daysMap = {
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday",
        "sun": "Sunday",
    };

    public monthIdMap = {
        "January": 1,
        "February": 2,
        "March": 3,
        "April": 4,
        "May": 5,
        "June": 6,
        "July": 7,
        "August": 8,
        "September": 9,
        "October": 10,
        "November": 11,
        "December": 12
    };

    appointmentDetail$: Subscription;
    appointmentSearch$: Subscription;
    appointmentSummary$: Subscription;
    booking$: Subscription;
    candidate$: Subscription;
    candidateData$: Subscription;
    client$: Subscription;
    country$: Subscription;
    eligibility$: Subscription;
    exam$: Subscription;
    hold$: Subscription;
    locationSelector$: Subscription;
    overlapsDate$: Subscription;
    overlapsFromDate$: Subscription;
    overlapsToDate$: Subscription;
    program$: Subscription;
    region$: Subscription;
    selectedAppointmentDetail$: Subscription;
    selectedAppointments$: Subscription;
    selectedEndDate$: Subscription;
    selectedStartDate$: Subscription;
    slotData$: Subscription;
    state$: Subscription;

    appointmentDetail: AppointmentDetail;
    appointmentSearch: AppointmentSearch;
    appointmentSummary: AppointmentSummary;
    booking: Booking;
    candidateData: Candidate;
    client: Client;
    countries: Country[] = [];
    country: Country;
    eligibility: Eligibility;
    exam: Exam;
    hold: Hold;
    locationSelector: LocationSelector;
    overlapsDate: string;
    overlapsFromDate: string;
    overlapsToDate: string;
    program: Program;
    region: State;
    selectedAppointments: AppointmentDetail[] = [];
    selectedStartDate: SelectedDate;
    selectedEndDate: SelectedDate;
    state: State;

    private anonymousRoutes: string[] = [
        '/home',
        '/scheduling/appointmentsearch',
        '/scheduling/cancelappointment/cancellation',
        '/scheduling/rescheduleappointment/reschedule',
        '/scheduling/scheduleappointment',
        '/scheduling/searchAvailability'
    ];

    constructor(
        private bootstrapParams: BootstrapParams,
        private domSanitizer: DomSanitizer,
        private httpService: HttpService,
        private loaderService: LoaderService,
        private router: Router,
        private selectedExamDetailService: SelectedExamDetailService,
        private translate: TranslateService,
        private zone: NgZone
    ) {
        this.candidate$ = selectedExamDetailService.candidate.subscribe(
            data => {
                this.candidate = data;
            });
    }

    print(printBody?: string): void {
        if (printBody) {
            let printContents, popupWin;
            printContents = document.getElementById('print-section').innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write(`
              <html>
                <head>
                  <title>Print tab</title>
                  <style>
                  //........Customized style.......
                  </style>
                </head>
            <body onload="window.print();window.close()">${printContents}</body>
              </html>`
            );
            popupWin.document.close();
        }
        else {
            window.print();
        }
    }

    private getResultArray(apiResponse: any): any[] {
        let resultArray = apiResponse.results;
        return resultArray || [];
    }

    TraverseModel<T>(inputList: any[], travserseModel: TravserseModel, token?: any): Observable<T[]> {
        let returnObjects: any[] = [];
        let filterItems: any[] = [];

        inputList.forEach(s =>
            filterItems.push(s[travserseModel.filterByName])
        );

        if (!travserseModel.onDemandLoading) {
            return new Observable((observer: Observer<T[]>) => {
                this.httpService.get(travserseModel.uri, token)
                    .pipe(map(this.getResultArray))
                    .subscribe((rArray: any) => {
                        rArray = rArray.filter(function(result: any) {
                            if (filterItems.indexOf(result[travserseModel.filterByName]) != -1) {
                                return true;
                            }
                            return false;
                        });
                        observer.next(rArray);
                        observer.complete();
                    });
            });
        }
    }

    getContent(
        contentType: string,
        contentLanguage: string,
        programCode: string
    ): Observable<ContentResponse> {
        var page = {
            'ProgramInfo': 'ProgramInformation',
            'PrivacyPolicyInfo': 'PolicyAgreementPAPrivacy',
            'BiometricConsent': 'BiometricConsent'
        };

        let pageName = page[contentType] ? page[contentType] : contentType;

        return new Observable((observer: Observer<any>) => {
            this.httpService.get(
                this.bootstrapParams.OrchestrationRootApiUrl +
                'api/v1/content/?programCode=' + programCode +
                '&page=' + pageName +
                '&culture=' + contentLanguage
            )
                .pipe(map(this.getFirstOrDefault))
                .subscribe((rArray: any) => {
                    let content = rArray.Results;
                    if (!!content) {
                        content = this.domSanitizer.sanitize(SecurityContext.HTML, content);
                        const transform = $('<notDiv/>').html(content);

                        transform.find('a[href^="http"]').each((i: number, a: HTMLAnchorElement) => {
                            a.target = '_blank';
                            a.rel = "noopener noreferrer";
                        });

                        content = transform[0].innerHTML
                    }

                    observer.next(new ContentResponse(
                        content,
                        contentType
                    ));
                    observer.complete();
                });
        });
    }

    private showLoader(): void {
        this.loaderService.show();
    }

    private hideLoader(): void {
        this.loaderService.hide();
    }

    public isDataValidToLoadComponent(componentType: ComponentType): boolean {
        let isDataValid: boolean = true;

        switch (componentType) {

            case ComponentType.FindAvailabilityComponent: {
                // Not being used currently, Using scheduling\searchAvailability for the same.
                break;
            }
            case ComponentType.ClientSelectorComponent: {
                // This component requires Client, program, Exam, Country & region. These info are not mandatory as it will show selected
                // if available otherwise blank dropdown will appear.
                break;
            }

            case ComponentType.ProgramSelectorComponent: {
                this.loadRequiredEntityfromService([EntityType.client]); // Only Client is required to load program.
                if (this.isNullOrUndefined(this.client)) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.ExamSelectorComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program]);

                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program)) { //Country & region not mandatory
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.ScheduleAppointmentComponent: {
                //Client & Program is required but not mandatory, screen will appear with dropdown to select info.
                break;
            }
            case ComponentType.ProgramInformationComponent: {
                this.loadRequiredEntityfromService([EntityType.client]); //Client id is required to read data from XML.
                if (this.isNullOrUndefined(this.client)) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.CustomAgreementComponent: {
                this.loadRequiredEntityfromService([EntityType.client]); //Client id is required to proceed further
                if (this.isNullOrUndefined(this.client)) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.AgreementComponent: {
                this.loadRequiredEntityfromService([EntityType.client]); //Client id is required to proceed further
                if (this.isNullOrUndefined(this.client)) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.EligibilitySelectorComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program]);
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program)) { // user need to enter Finra details & Exam
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.LocationSelectorComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program, EntityType.selectedAppointmentDetail]);

                // if there is object in selectedAppointments it means it will have Exam, program, & Eligibilty (for Schedule).
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.TimezoneSelectorComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program, EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.ScheduleLocationComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program, EntityType.selectedAppointmentDetail]);

                // if there is object in selectedAppointments it means it will have Exam, program, & Eligibilty (for Schedule).
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.BiometricConsentComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program, EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program) || this.selectedAppointments.length < 1) { // user need to enter Finra details & Exam
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.FindAvailabilityLocationComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program, EntityType.selectedAppointmentDetail]);
                // if there is object in selectedAppointments it means it will have Exam, program, & Eligibilty (for Schedule).
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.TestCenterSelecterComponent: {

                this.loadRequiredEntityfromService([
                    EntityType.client,
                    EntityType.program,
                    EntityType.selectedAppointmentDetail,
                    EntityType.selectedStartDate,
                    EntityType.selectedEndDate,
                ]);
                if (this.isNullOrUndefined(this.client) ||
                    this.isNullOrUndefined(this.program) ||
                    this.selectedAppointments.length < 1 ||
                    this.isNullOrUndefined(this.selectedStartDate) ||
                    this.isNullOrUndefined(this.selectedEndDate)
                ) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.ScheduleTestCenterComponent:
            case ComponentType.MultidayTestCenterComponent: {

                this.loadRequiredEntityfromService([
                    EntityType.client,
                    EntityType.program,
                    EntityType.selectedAppointmentDetail,
                    EntityType.selectedStartDate,
                    EntityType.selectedEndDate,
                ]);
                if (this.isNullOrUndefined(this.client) ||
                    this.isNullOrUndefined(this.program) ||
                    this.selectedAppointments.length < 1 ||
                    this.isNullOrUndefined(this.selectedStartDate) ||
                    this.isNullOrUndefined(this.selectedEndDate)
                ) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.CandidateProfileComponent: {

                this.loadRequiredEntityfromService([
                    EntityType.client,
                    EntityType.program,
                    EntityType.selectedAppointmentDetail,
                    EntityType.selectedStartDate,
                    EntityType.selectedEndDate,
                    EntityType.hold
                ]);

                if (this.isNullOrUndefined(this.client) ||
                    this.isNullOrUndefined(this.program) ||
                    this.selectedAppointments.length < 1 ||
                    this.isNullOrUndefined(this.selectedStartDate) ||
                    this.isNullOrUndefined(this.selectedEndDate) ||
                    this.isNullOrUndefined(this.hold)
                ) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.VerificationDetailComponent: {
                this.loadRequiredEntityfromService([EntityType.booking,
                EntityType.candidateData,
                EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.booking) ||
                    this.isNullOrUndefined(this.candidateData) ||
                    this.selectedAppointments.length < 1
                ) {
                    isDataValid = false;
                }

                break;
            }
            case ComponentType.ConfirmationComponent: {
                this.loadRequiredEntityfromService([
                    EntityType.candidateData,
                    EntityType.selectedAppointmentDetail
                ]);
                if (
                    this.isNullOrUndefined(this.candidateData) ||
                    this.selectedAppointments.length < 1
                ) {
                    isDataValid = false;
                }
                isDataValid = this.isAnyAppointmentExitWithoutHold(this.selectedAppointments, isDataValid);
                break;
            }
            case ComponentType.AppointmentSearchComponent: {
                // No mandatory data is required. User can search and get the details.
                break;
            }
            case ComponentType.AppointmentInfoComponent: {
                // Based on the available data it will show detail in right panel.
                break;
            }
            case ComponentType.RescheduleComponent: {
                // No mandatory data is required. User can search and get the details.
                break;
            }
            case ComponentType.RescheduleAppointmentComponent: {
                // No mandatory data is required. User can search and get the details.
                break;
            }
            case ComponentType.RescheduleLocationComponent: {
                this.loadRequiredEntityfromService([EntityType.booking, EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.booking) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.RescheduleTestCenterComponent:
            case ComponentType.RescheduleMultidayTestCenterComponent: {

                this.loadRequiredEntityfromService([
                    EntityType.booking,
                    EntityType.selectedAppointmentDetail,
                    EntityType.selectedStartDate,
                    EntityType.selectedEndDate,
                ]);

                if (this.isNullOrUndefined(this.booking) ||
                    (this.selectedAppointments.length < 1 ||
                        this.isNullOrUndefined(this.selectedStartDate) ||
                        this.isNullOrUndefined(this.selectedEndDate)
                    )) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.RescheduleMultidaySessionComponent: {

                this.loadRequiredEntityfromService([
                    EntityType.booking,
                    EntityType.selectedAppointmentDetail
                ]);

                if (this.isNullOrUndefined(this.booking) ||
                    (this.selectedAppointments.length < 1
                    )) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.FindAvailabilityTestcenterComponent: {

                this.loadRequiredEntityfromService([
                    EntityType.selectedAppointmentDetail,
                    EntityType.selectedStartDate,
                    EntityType.selectedEndDate,
                ]);

                if (this.selectedAppointments.length < 1 ||
                    this.isNullOrUndefined(this.selectedStartDate) ||
                    this.isNullOrUndefined(this.selectedEndDate)
                ) {
                    isDataValid = false;
                }
                break;
            }

            case ComponentType.PaymentComponent: {
                this.loadRequiredEntityfromService([EntityType.selectedAppointmentDetail]);
                if (this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                // Verify that slot has been selected for all selected appointments.
                // isDataValid = this.isAnyAppointmentExitWithoutHold(this.selectedAppointments, isDataValid);
                break;
            }
            case ComponentType.ReconfirmationComponent: {

                this.loadRequiredEntityfromService([
                    EntityType.booking,
                    EntityType.selectedAppointmentDetail,
                ]);

                if (this.isNullOrUndefined(this.booking) ||
                    this.selectedAppointments.length < 1
                ) {
                    isDataValid = false;
                }

                isDataValid = this.isAnyAppointmentExitWithoutHold(this.selectedAppointments, isDataValid);

                break;
            }
            case ComponentType.CancellationComponent: {
                // No mandatory data is required. User can search and get the details.
                break;
            }
            case ComponentType.CancellationAppointment: {
                // No mandatory data is required. User can search and get the details.
                break;
            }
            case ComponentType.PaymentCancellationComponent: {
                this.loadRequiredEntityfromService([EntityType.booking, EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.booking) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.CancellationVerificationComponent: {
                this.loadRequiredEntityfromService([EntityType.booking, EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.booking) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.CancellationConfirmationComponent: {
                this.loadRequiredEntityfromService([EntityType.booking, EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.booking) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.FindAvailabilityProctorComponent:
            case ComponentType.ScheduleProctorComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program, EntityType.selectedAppointmentDetail]);
                // if there is object in selectedAppointments it means it will have Exam, program, & Eligibilty (for Schedule).
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
            case ComponentType.RescheduleProctorComponent: {
                this.loadRequiredEntityfromService([EntityType.booking, EntityType.selectedAppointmentDetail]);
                if (this.isNullOrUndefined(this.booking) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;

            }
            case ComponentType.FindAvailabilityTimezoneComponent:
            case ComponentType.ScheduleTimezoneComponent: {
                this.loadRequiredEntityfromService([EntityType.client, EntityType.program, EntityType.selectedAppointmentDetail]);
                // if there is object in selectedAppointments it means it will have Exam, program, & Eligibilty (for Schedule).
                if (this.isNullOrUndefined(this.client) || this.isNullOrUndefined(this.program) || this.selectedAppointments.length < 1) {
                    isDataValid = false;
                }
                break;
            }
        }
        if (isDataValid == false) {
            this.selectedExamDetailService.resetExamService();
            this.router.navigate(['/home']);
        };
        return isDataValid;
    }

    public isNullOrUndefined(object: any): boolean {
        if (object == null || object == undefined) {
            return true;
        }
        else { return false; }
    }

    private isAnyAppointmentExitWithoutHold(selectedAppointments: AppointmentDetail[], isDataValid: boolean): boolean {
        if (this.selectedAppointments && this.selectedAppointments.length > 0) {
            this.selectedAppointments.forEach((appointment) => {
                if (!this.isNullOrUndefined(appointment.hold)) {
                    isDataValid = (this.isNullOrUndefined(appointment.hold.id)) ? false : isDataValid;
                    if (!isDataValid) {
                        isDataValid = !!appointment.exam.sessions[0].hold;
                    }
                }
                else {
                    isDataValid = false;
                }
            });
        }
        else { isDataValid = false; }
        return isDataValid;
    }

    private loadRequiredEntityfromService(requiredEntities: EntityType[]): void {
        requiredEntities.forEach((entityType) => {
            switch (entityType) {
                case EntityType.client: {
                    this.client$ = this.selectedExamDetailService.client.subscribe(
                        client => {
                            this.client = client;
                        });
                    break;
                }
                case EntityType.program: {
                    this.program$ = this.selectedExamDetailService.program.subscribe(program => {
                        this.program = program;
                    });
                    break;
                }
                case EntityType.exam: {
                    this.exam$ = this.selectedExamDetailService.exam.subscribe(exam => {
                        this.exam = exam;
                    });
                    break;
                }
                case EntityType.selectedStartDate: {
                    this.selectedStartDate$ = this.selectedExamDetailService.selectedStartDate.subscribe(selectedStartDate => {
                        this.selectedStartDate = selectedStartDate;
                    });
                    break;
                }
                case EntityType.selectedEndDate: {
                    this.selectedEndDate$ = this.selectedExamDetailService.selectedEndDate.subscribe(selectedEndDate => {
                        this.selectedEndDate = selectedEndDate;
                    });
                    break;
                }
                case EntityType.selectedAppointmentDetail: {
                    this.selectedAppointments$ = this.selectedExamDetailService.selectedAppointmentDetails.subscribe(
                        selectedAppointments => {
                            this.selectedAppointments = this.isNullOrUndefined(selectedAppointments) ? [] : selectedAppointments;
                        });
                    break;
                }
                case EntityType.hold: {
                    this.hold$ = this.selectedExamDetailService.hold.subscribe(hold => {
                        this.hold = hold;
                    });
                    break;
                }
                case EntityType.booking: {
                    this.booking$ = this.selectedExamDetailService.booking.subscribe(booking => {
                        this.booking = booking;
                    });
                    break;
                }
                case EntityType.candidateData: {
                    this.candidateData$ = this.selectedExamDetailService.candidate.subscribe(candidate => {
                        this.candidateData = candidate;
                    });
                    break;
                }
            }
        });
    }

    // Common Methods
    public durationToStr(val: number) {
        if (val > 0) {
            let m = val % 60;
            let h = (val - m) / 60;
            return { hours: h, minutes: m };
        }
    }

    // Set Fomat on the basis
    public getFormatToMMDDYYYY(value: any, seperator: string): any {
        let formatedValue: any = '';
        switch (seperator) {

            case "-":
                formatedValue = moment(value).format('MM-DD-YYYY');
                break;
            case "/":
                formatedValue = moment(value).format('MM/DD/YYYY');
                break;

            case ",":
                formatedValue = moment(value).format('MMM DD, YYYY');
                break;
        }
        return formatedValue;
    }

    public convertDateToWords(value: string, seperator: string) {
        let formatedValue: string = '';
        switch (seperator) {

            case "-":
                formatedValue = moment(value).format('MMMM D - YYYY');
                break;
            case "/":
                formatedValue = moment(value).format('MMMM D / YYYY');
                break;

            case ",":
                formatedValue = moment(value).format('MMMM D, YYYY');
                break;
        }
        return formatedValue;
    }

    public getFormatToFullMMDDYYYY(value: any, seperator: string): any {
        let formatedValue: any = '';
        switch (seperator) {

            case "-":
                formatedValue = moment(value).format('MM-DD-YYYY hh:mm A');
                break;
            case "/":
                formatedValue = moment(value).format('MM/DD/YYYY hh:mm A');
                break;
        }
        return formatedValue;
    }

    public hasUnicode(inputsString: string) {
        for (var i = 0; i < inputsString.length; i++) {
            if (inputsString.charCodeAt(i) > 127) return true;
        }
        return false;
    }

    public getValidEligibilityDates(overLapStartDate: Date, overLapEndDate: Date) {
        //return undefined if missing data
        if (!overLapStartDate || !overLapEndDate) {
            return undefined;
        }
        // set start to start date that was passed in or tomorrow, whichever is later
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1)
        let startDate = new Date(overLapStartDate);
        tomorrow.setHours(0, 0, 0, 0);
        if (startDate < tomorrow) {
            startDate = tomorrow;
        }
        let start = {
            year: startDate.getFullYear(),
            month: startDate.getMonth() + 1,
            day: startDate.getDate(),
        }

        // set end to end date that was passed in
        const endDate = new Date(overLapEndDate);
        let end = {
            year: endDate.getFullYear(),
            month: endDate.getMonth() + 1,
            day: endDate.getDate(),
        }

        // return undefined if the range provided is larger that the allowable selection (start+14 days)
        let range = this.getDaysBetween(start, end)
        if (range > 14 || range < 0) {
            return undefined;
        }

        //return valid range: 'date' for the location-selection page 'jsdate' for the API call
        return [
            {
                date: start,
                jsdate: startDate,
            },
            {
                date: end,
                jsdate: endDate,
            }
        ];
    }

    public getEligibleMonth(overLapStartDate: Date) {
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1)
        //return tomorrow if no start date
        if (!overLapStartDate) {
            return tomorrow.getFullYear().toString() + "-" + (tomorrow.getMonth() + 1).toString();
        }

        // set start to start date that was passed in or tomorrow, whichever is later
        let startDate = new Date(overLapStartDate);
        if (startDate < tomorrow) {
            startDate = tomorrow;
        }

        return startDate.getFullYear().toString() + "-" + (startDate.getMonth() + 1).toString();
    }

    public getVoucherStartEndDates(voucherExpDate: any, eligStart: any, eligEnd: any) {
        let start = moment().add(1, 'days').format('MM/DD/YYYY');
        let voucherEnd = moment(voucherExpDate).format('MM/DD/YYYY');


        if (!eligStart || !eligEnd) {
            return [start, voucherEnd];
        } else {
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0);

            let startDate = new Date(eligStart);

            if (startDate < tomorrow) {
                startDate = tomorrow;
            }

            start = moment(startDate).format('MM/DD/YYYY');

            let endDate = new Date(eligEnd);

            if (new Date(voucherExpDate) < endDate) {
                endDate = new Date(voucherExpDate);
            }

            let end = moment(endDate).format('MM/DD/YYYY');

            return [start, end]
        }
    }

    public getValidStart(overlapDate: Date): Date {
        let start = new Date();
        start.setHours(0, 0, 0, 0);
        start.setDate(start.getDate() + 1);
        if (overlapDate) {
            const date = new Date(overlapDate);
            let year = date.getFullYear();
            let month = date.getMonth();
            let day = date.getDate();
            if (start.valueOf() < date.valueOf()) start = date;
        }
        start.setDate(start.getDate());
        return start;
    }

    public getValidStartDateEnd(overLapStartDate: Date, overLapEndDate: Date): Date {

        let end = undefined;
        if (overLapStartDate) {
            const date = new Date(overLapEndDate);
            date.setDate(date.getDate());
            end = date;
        }
        return end;
    }

    public getTodayDate(componentType?: string) {
        if (componentType == "daterange") {
            const year = new Date().getFullYear();
            const month = new Date().getMonth() + 1;
            const day = new Date().getDate() - 1;

            return {
                year: year,
                month: month,
                day: day
            }
        }
        else {
            const today = new Date();
            today.setDate(today.getDate() + 1);
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const day = today.getDate();
            return {
                year: year,
                month: month,
                day: day
            }
        }

    }

    public getValidEndDateEnd(selectedStartDate: any, overLapEndDate: Date, additionalDay: number): Date {
        const beginDate = selectedStartDate;
        var year = beginDate.year;
        var month = beginDate.month;
        var day = beginDate.day;
        var endStart = new Date(year, month - 1, day);
        endStart.setDate(endStart.getDate() + additionalDay);
        if (overLapEndDate) {
            const date = new Date(overLapEndDate);
            date.setDate(date.getDate());
            let endYear = date.getFullYear();
            let endMonth = date.getMonth();
            let endDay = date.getDate();
            const startEndDate = new Date(endYear, endMonth, endDay);
            if (endStart.valueOf() >= startEndDate.valueOf()) endStart = startEndDate;
        }

        return endStart;
    }

    public getValidEndDateStart(selectedStartDate: any, additionalDay: number = 0): Date {
        const beginDate = selectedStartDate;
        var year = beginDate.year;
        var month = beginDate.month;
        var day = beginDate.day
        var endStart = new Date(year, month - 1, day);
        endStart.setDate(endStart.getDate() + additionalDay);

        return endStart;
    }

    /**
     * This is for end date beginning on Range for Multiday
     * @param selectedStartDate
     */
    public getRangeEndDateStart(selectedStartDate: any) {
        const beginDate = selectedStartDate;
        var year = beginDate.year;
        var month = beginDate.month;
        var day = beginDate.day
        var endStart = new Date(year, month - 1, day);
        //endStart.setDate(endStart.getDate() + 1);

        return {
            year: endStart.getFullYear(),
            month: endStart.getMonth() + 1,
            day: endStart.getDate(),
        }
    }

    /**
     * This is for end date end on Range for Multiday
     * @param selectedStartDate
     * @param daysToAdd
     */
    public getRangeEndDateEnd(selectedStartDate: any, daysToAdd: number, overLapEndDate: Date) {
        const beginDate = selectedStartDate;
        var year = beginDate.year;
        var month = beginDate.month;
        var day = beginDate.day;
        const endStart = new Date(year, month - 1, day);

        let rangeEndDate = moment(overLapEndDate).format('MM-DD-YYYY');;
        // set session dates
        let maxEndDate = moment(endStart).add(daysToAdd, 'day').format('MM-DD-YYYY');
        if (moment(overLapEndDate, 'MM-DD-YYYY').isBefore(maxEndDate)) {
            //this.maxEndDateLimit = this.overLapEndDate;
            //this.selectedExamDetailService.setmaxEndDateLimit(this.overLapEndDate);
            rangeEndDate = moment(overLapEndDate).format('MM-DD-YYYY');
        } else {
            //this.maxEndDateLimit = maxEndDate;
            //this.selectedExamDetailService.setmaxEndDateLimit(maxEndDate);
            rangeEndDate = maxEndDate;
        }
        return {
            year: moment(rangeEndDate).year(),
            month: (moment(rangeEndDate).month()) + 1,
            day: moment(rangeEndDate).date() + 1,
        }
    }

    public ConvertToAMPM(time: any, timeFormat: boolean) {
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
        if (time.length > 1) { // If time format correct
            time = time.slice(1);  // Remove full string match value
            if (!timeFormat) { // use 24 hour format?
                time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
        }
        return time.join(''); // return adjusted time or original string
    }

    /**
     * get days between two dates
     * expected format - date: {
        year: year,
        month: month,
        day: day
       }
     * @param start
     * @param end
     */
    public getDaysBetween(start: any, end: any) {
        const startDate = moment([start.year, (start.month) - 1, start.day]);
        const endDate = moment([end.year, (end.month) - 1, end.day]);
        return endDate.diff(startDate, 'days');
    }

    // Handle time using string to Fix Timezone issue. (need to handle date/time at global level in seprate task)
    public getTimeString(startDateTime: any, timeFormat: boolean): string {
        let returndata: any = "";
        if (startDateTime == "") return returndata;
        let tempTime: string = (startDateTime).toString().split('T')[1].split('-')[0]
        if (tempTime) {
            if (tempTime.split(":")[0].length < 2) {
                tempTime = "0" + tempTime.split(":")[0] + ":" + tempTime.split(":")[1];
            }
            else {
                tempTime = tempTime.split(":")[0] + ":" + tempTime.split(":")[1];
            }
            returndata = this.ConvertToAMPM(tempTime, timeFormat);
        }
        return returndata;
    }

    public getStartEndFormat(start: Date): string {
        if (!!start) {
            const date = moment(start).format('YYYY-MM-DDTHH:mm:ss');
            const formattedTime = this.getTimeString(date, this.selectedExamDetailService.timeFormat);
            return formattedTime;
        }
        return "";
    }

    static addMins(start: Date, duration: number): Date {
        start = new Date(start);
        let end = start;
        end.setMinutes(start.getMinutes() + duration);
        return end;
    }
    /**
     * sort exams by startDateTime
     * can be made more generic
     * @param arr
     */
    public dateSortAsc(arr: AppointmentDetail[]) {
        return arr.slice().sort(function(a, b) {
            return (new Date(b['appointmentSlot']['startDateTime'])).getTime()
                > (new Date(a['appointmentSlot']['startDateTime'])).getTime() ? -1 : 1;
        });
    }

    //strict compare two objects or functions with there properties and values
    deepCompare(leftChain: any, rightChain: any) {
        let i, l;

        function compareObjects(x: any, y: any) {
            let p;

            if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
                return true;
            }

            // Check if both arguments link to the same object.
            if (x === y) {
                return true;
            }

            // Comparing dates is a common scenario. Another built-ins
            if ((typeof x === 'function' && typeof y === 'function') ||
                (x instanceof Date && y instanceof Date) ||
                (x instanceof RegExp && y instanceof RegExp) ||
                (x instanceof String && y instanceof String) ||
                (x instanceof Number && y instanceof Number)) {
                return x.toString() === y.toString();
            }

            // Checking prototypes
            if (!(x instanceof Object && y instanceof Object)) {
                return false;
            }

            if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
                return false;
            }

            if (x.constructor !== y.constructor) {
                return false;
            }

            if (x.prototype !== y.prototype) {
                return false;
            }

            // Check for infinitive linking loops
            if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
                return false;
            }

            for (p in y) {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                    return false;
                }
                else if (typeof y[p] !== typeof x[p]) {
                    return false;
                }
            }

            for (p in x) {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                    return false;
                }
                else if (typeof y[p] !== typeof x[p]) {
                    return false;
                }

                switch (typeof (x[p])) {
                    case 'object':
                    case 'function':

                        leftChain.push(x);
                        rightChain.push(y);

                        if (!compareObjects(x[p], y[p])) {
                            return false;
                        }
                        leftChain.pop();
                        rightChain.pop();
                        break;
                    default:
                        if (x[p] !== y[p]) {
                            return false;
                        }
                        break;
                }
            }
            return true;
        }
        if (arguments.length < 1) {
            return true;
        }
        for (i = 1, l = arguments.length; i < l; i++) {
            leftChain = [];
            rightChain = [];
            if (!compareObjects(arguments[0], arguments[i])) {
                return false;
            }
        }
        return true;
    }

    // return the role attribute object with provided value.
    getRoleAttribute(roleType: string): any {
        let roleAttribute: any = document.createAttribute("role");
        roleAttribute.value = roleType;
        return roleAttribute;
    }

    // return the area lebel attribute object with provided value.
    getAriaLabelAttribute(areaLblValue: string): any {
        let areaLabelAttribute: any = document.createAttribute("aria-label");
        areaLabelAttribute.value = areaLblValue;
        return areaLabelAttribute;
    }

    // return the area label attribute object with provided value.
    getAriaLiveAttribute(areaLblValue: string): any {
        let areaLabelAttribute: any = document.createAttribute("aria-live");
        areaLabelAttribute.value = areaLblValue;
        return areaLabelAttribute;
    }

    // return the area label attribute object with provided value.
    getIdAttribute(id: string): any {
        let idAttribute: any = document.createAttribute("id");
        idAttribute.value = id;
        return idAttribute;
    }

    // cleaning up the existing attribute on specific object.
    cleanUpAttribute(domObject: any): any {
        if (domObject.hasAttribute("role")) {
            domObject.removeAttribute("role");
        }
        if (domObject.hasAttribute("aria-label")) {
            domObject.removeAttribute("aria-label");
        }
        return domObject;
    }

    getFirstOrDefault(apiResponse: any): any {
        let resultArray: any = (apiResponse.results !== undefined) ? apiResponse.results : apiResponse;
        return resultArray;
    }

    getNewToken(token: any): Observable<any> {
        let location = window.location.origin + '/refreshToken';
        return new Observable((observer: Observer<any>) => {

            this.httpService.post(location, JSON.stringify(token), token)
                .pipe(map(this.getFirstOrDefault))
                .subscribe({
                  next: (rNArray) => {
                    const refreshedToken = {
                      token: rNArray.Token,
                      expire: rNArray.ExpirationDate
                    }

                    observer.next(refreshedToken);
                    observer.complete();
                  },
                  error: (err) => {
                    observer.next(null);
                    observer.complete();
                  }
                });
        });
    }

    /**
     * Removes 'role="tab"' from <div class="panel-heading card-header" role="tab"> inserted into page for accordion
     * Level access asked us to remove the role="tab" and it isn't in our code so we have to edit it after the insert
     */
    public removeAccordionTabRole(): void {
        $('div.panel-heading.card-header[role="tab"]').each((i: number, d: HTMLDivElement) => {
            d.removeAttribute('role');
        });
    }
}
